import * as TypeGraphQL from "type-graphql";
export var AlertStatus;
(function (AlertStatus) {
    AlertStatus["ACTIVE"] = "ACTIVE";
    AlertStatus["ACKNOWLEDGED"] = "ACKNOWLEDGED";
    AlertStatus["RESOLVED"] = "RESOLVED";
    AlertStatus["SUPPRESSED"] = "SUPPRESSED";
})(AlertStatus || (AlertStatus = {}));
TypeGraphQL.registerEnumType(AlertStatus, {
    name: "AlertStatus",
    description: undefined,
});
//# sourceMappingURL=AlertStatus.js.map